import AccionRow from "./AccionRow";

const AccionesTable = ({ acciones, search }) => {
  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0" style={{ minWidth: "900px" }}>
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "60px" }}>
              ID
            </th>
            <th scope="col" style={{ minWidth: "280px" }}>
              Frase / Acción
            </th>
            <th scope="col" style={{ minWidth: "200px" }}>
              Área
            </th>
            <th scope="col" style={{ minWidth: "180px" }}>
              Talento
            </th>
            <th scope="col" style={{ minWidth: "100px" }}>
              Estado
            </th>
            <th scope="col" style={{ minWidth: "80px" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {acciones.map((accion) => (
            <AccionRow key={accion.id} accion={accion} search={search} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AccionesTable;
